import { MessageSquare, Dna, FileSpreadsheet, Database, Target, Trophy, BookOpen, ClipboardCheck } from "lucide-react";
const FeatureBlocksSection = () => {
  const features = [{
    icon: MessageSquare,
    emoji: "🔹",
    title: "Chat com IA Especializada",
    items: ["Copywriting", "Lançamentos", "Tráfego pago", "Estratégias de vendas", "Conteúdo e branding"],
    tagline: "Parece que você tem um consultor 24/7."
  }, {
    icon: Dna,
    emoji: "🔹",
    title: "Product DNA (IA que te entende)",
    items: ["Nicho", "Avatar", "Dor", "Transformação", "Objetivo", "Tom de voz"],
    tagline: "Sua IA sabe exatamente como sua marca fala."
  }, {
    icon: FileSpreadsheet,
    emoji: "🔹",
    title: "Planilhas Inteligentes",
    items: ["Funis", "Vendas", "Finanças", "Conteúdo", "Tráfego", "ROI", "Planejamento anual"],
    tagline: "Tudo integrado com dados reais."
  }, {
    icon: Database,
    emoji: "🔹",
    title: "Central de Dados Completa",
    items: ["Leads", "Produtos", "Finanças", "Campanhas", "Métricas"],
    tagline: "Seu negócio totalmente organizado."
  }, {
    icon: ClipboardCheck,
    emoji: "🔹",
    title: "SmartCheck IA",
    items: ["Checklists gerados por IA", "Templates por nicho", "Ferramentas sugeridas", "Progresso gamificado", "Exportar em PDF"],
    tagline: "Transforme planos em ação guiada."
  }, {
    icon: Target,
    emoji: "🔹",
    title: "Desafios de Implementação",
    items: ["Criar seu primeiro funil", "Rodar sua primeira campanha", "Montar calendário editorial", "Organizar seu financeiro", "Estruturar lançamento completo"],
    tagline: "Aprenda fazendo."
  }, {
    icon: Trophy,
    emoji: "🔹",
    title: "Gamificação",
    items: ["Pontos", "Streaks", "Ranking", "Badges"],
    tagline: "Motivação diária para nunca parar."
  }, {
    icon: BookOpen,
    emoji: "🔹",
    title: "E-books & Materiais",
    items: ["Funis", "Tráfego", "Conteúdo", "Copywriting"],
    tagline: "Conhecimento pronto para usar."
  }];
  return <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-4">
            🛠️ Módulos da Plataforma
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Tudo que você precisa em um único lugar
          </p>
        </div>

        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => <div key={index} className="bg-card p-8 rounded-xl shadow-medium hover:shadow-lg transition-all hover:-translate-y-1">
              {/* Icon */}
              <div className="mb-6">
                <div className="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center">
                  <feature.icon className="w-8 h-8 text-primary" />
                </div>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-foreground mb-4">
                {feature.emoji} {feature.title}
              </h3>

              {/* Items */}
              <ul className="space-y-2 mb-4">
                {feature.items.map((item, idx) => <li key={idx} className="flex items-start gap-2">
                    <span className="text-primary mt-1">•</span>
                    <span className="text-muted-foreground">{item}</span>
                  </li>)}
              </ul>

              {/* Tagline */}
              <p className="text-sm font-semibold text-primary italic mt-4 pt-4 border-t border-border">
                {feature.tagline}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default FeatureBlocksSection;